import { Chip } from '@/shared/ui/components';
import { gettextStudyType } from '@/shared/lib';
import { t } from 'ttag';
import type { StudyTypeFormatterProps } from './studyTypeFormatter.types';
import './studyTypeFormatter.scss';

/**
 * Stands in as the default handler where the study type formatter expects a callback but none is supplied. Takes no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

const StudyTypeFormatter = ({
  isTextButton = false,
  handleClick = NOOP,
  isDisabled = false,
  studyType,
  isFollowOnStudy,
}: StudyTypeFormatterProps) => {
  if (isTextButton) {
    return (
      <button disabled={isDisabled} onClick={handleClick} className="study-type-text-btn">
        <span>{studyType ? gettextStudyType(studyType) : ''}</span>
      </button>
    );
  }
  return (
    <div className="flex items-center flex-wrap">
      <div>{studyType ? gettextStudyType(studyType) : ''}</div>
      {isFollowOnStudy && (
        <Chip
          style={{
            marginLeft: 8,
            border: 1,
            paddingInline: 8,
            fontWeight: 500,
          }}
          background="#DEF5EF"
          color="#045C45"
          closable={false}
        >
          {t`Follow-on`}
        </Chip>
      )}
    </div>
  );
};

export default StudyTypeFormatter;
